import * as classnames from 'classnames';
export var namespaceClassName = 'aul';
export var namespacedClassnames = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return classnames(namespaceClassName, args);
};
//# sourceMappingURL=namespace-classes.js.map